<div class="container-fluid p-0">
  <app-header></app-header>
  <ng-content select="router-outlet"></ng-content>
  <app-footer></app-footer>
</div>
